import { db } from "../../../../config/firebase.config";
import create from "zustand";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
// @firebase/firestore
import {
  doc,
  setDoc,
  serverTimestamp,
  collection,
  getDocs
} from "firebase/firestore";

export const useStore = create((set,get) => ({
  cartUrl: "",
  quantity: null,
  cartModal: [],
  cartTotal: 0,
  products: [],
  myCart: null,
  openCartNav: false,
  openCartCollect: false,
  showSearchState: false,
  showMobileNavState: false,
  addCartTotal: (payload) => {
    set({cartTotal:payload});
  },
  addToCart: async (payload) => {
    const data = payload.item;
    try {
          setDoc(doc(db, "users", payload.uid.split('Customer/').pop()), {
          cart: data,
          lastModified: serverTimestamp()
        },{merge: true});
        toast("Your cart added", { ...config, type: "success"})
      } catch (error) {
        toast("Issues updating cart", { ...config, type: "error"})
        return error;
      }
  },
  getNewQuantity:(payload) => {
    if (payload) {
      set({quantity: payload});
    }
    else{
      set({quantity: 0});
    }
    return payload;
  },
  navCartSlider: async (payload) => {
    try {
      let arr = [];
      const querySnapshot = await getDocs(collection(db, "products"));
      querySnapshot.forEach((doc) => {
        arr.push(doc.data());
      });
      payload.map((item) => {
        arr.map((doc) => {
          if(item.merchandise.product.handle = doc.handle) {
            doc.variants.map(variant => {
              if(variant.title === item.merchandise.title) {
                item.merchandise.inventory_quantity =  variant.inventory_quantity
              }
            })
          }
        })
      })
      // 🐇🥚 : Below is used to handle the spinner on cart page
      payload.length === 0 ? payload = null : null
      // 🥚🐇 : Above is used to handle the spinner on cart page
      set({cartModal: payload})
    } catch (error) {
      toast("Error fetching the products", {
        ...config,
        type: "error",
      });
    }
  },
  toggelCart: () => {
    set(state => ({
      openCartNav: !state.openCartNav
    }))
  },
  toggelShowSearch: () => {
    set((state) => ({
      showSearchState: !state.showSearchState,
    }));
  },
  showMobileNavStateToggle: () => {
    set((state) => ({
      showMobileNavState: !state.showMobileNavState,
    }));
  },
  toggelShowSearchFalse: () => {
    set({
      showSearchState: false,
    });
  },
  toggleMobileNavFalse: () => {
    set({
      showMobileNavState: false,
    });
  },
  toggelCartFalse: () => {
    set({
      openCartNav: false,
    });
  },
  checkoutPreperation: (payload) => {
    set({myCart: payload})
  }
}))